import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import LibraryItem from '../../containers/library-item.jsx';
import Modal from '../../containers/modal.jsx';
import Divider from '../divider/divider.jsx';
import Filter from '../filter/filter.jsx';
import TagButton from '../../containers/tag-button.jsx';
import Spinner from '../spinner/spinner.jsx';

import { ComingSoonTooltip } from '../coming-soon/coming-soon.jsx';

// import LoginDropdown from '../../components/library/library.jsx'
import LoginDropdown from '../menu-bar/login-dropdown.jsx';
import UnityGameModal from './unityGameModal.jsx'; // Adjust the path as needed
import Arvrdocs from './ar-vr-docs.jsx';
// import Arvrdocs from './arvr_class.jsx';
import Appdocs from './appDev/app.jsx';
import HTMLEditor from './htmlEditor/App.jsx';
import Design from './design/design-docs.jsx';
import Appdev from './appdev/appdev.jsx';

import Robotics from './Robotics.jpg';
import artificialintelligence from './artificialintelligence.jpg';
import math from './math.jpg';
import HtmlEditorImage from './web_dev.jpg';
import geography from './Geography.jpg';
import iot from './iot.jpg';
import ar from './ar.jpg';
import printing from './printing.jpg';
import codingImg from './codingimg.jpg';
import cyber from './cyber.jpg';
import drons from './drons.jpg';
import gameEnvironmentImage from './gameEnvironmentImage.jpg';
import mlImage from './mlImage.jpg';
import allExtensions from './allExtensions.jpg';
import mitAppInventorImage from './app_dev.jpg';
import { LogIn, ChevronLeftCircleIcon, LogOut, Code, PuzzleIcon as PuzzlePiece, X, Terminal } from 'lucide-react';
import Button from '../button/button.jsx';
// import MLEnv from '../../App.js';
import MLEnv from './MLEnv.js';
import styles from './library.css';
import apiClient from '../../utils/apiClient';
import { isExtensionAccessible } from '../../lib/libraries/extensions/extensionModules';

const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

const ALL_TAG = { tag: 'all', intlLabel: messages.allTag };
const tagListPrefix = [ALL_TAG];

// const [selectedButton, setSelectedButton] = useState('');

class LibraryComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handleMouseEnter',
            'handleMouseLeave',
            'handlePlayingEnd',
            'handleSelect',
            'handleTagClick',
            'setFilteredDataRef',
            'handleBackButtonClick',
            'handleButtonMouseEnter', // Add this line
            'handleButtonMouseLeave',
            'signInButtonOnClick',
            'handleSignInButtonClick',
            'handleSignOutButtonClick',
            'isUserLoggedIn',
            'handleML',
            'handleRoboticsOptionSelect',
            'handleAuthUpdate',
            'hasAccessibleCategory'
        ]);
        this.state = {
            playingItem: null,
            filterQuery: '',
            selectedTag: ALL_TAG.tag,
            loaded: true,
            buttonsVisible: true,
            showData: false,
            hoveredButton: null, // Add this line
            selectedButton: '', // New state variable
            dropdownVisible: false,
            dropdownManuallyOpened: false,
            showModal: false, // New state for controlling the new modal
            isUnityModalOpen: false,
            isArvrModalOpen: false,
            isAppModalOpen: false,
            isHtmlModalOpen: false,
            isDesignModalOpen: false,
            isHandleModalOpen: false,
            isSignInButtonDisabled: true,
            isLoggedIn: Boolean(localStorage.getItem('accessToken')),
            isRoboticsModalOpen: false,
            selectedRoboticsOption: null // To track which option user selects
        };

        this.dropdownRef = React.createRef(); // Create ref for dropdown
        this.filteredDataRef = React.createRef(); // Create ref for filtered data
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }


    // Toggle dropdown visibility on button click
    handleSignInButtonClick() {

        // Your existing sign-in logic here
        this.setState(prevState => ({
            dropdownVisible: !prevState.dropdownVisible,
            dropdownManuallyOpened: true
        }));
        localStorage.setItem('isLoginModalOpen', true);

    }

    // Handle clicks outside the dropdown
    // handleClickOutside(event) {
    //     if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
    //         this.setState({ dropdownVisible: false });
    //     }
    // }
    handleUnityModalToggle = isOpen => {
        this.setState({ isUnityModalOpen: isOpen });
    };
    handleMlModal = isOpen => {
        this.setState({ isHandleModalOpen: isOpen });
    };
    handleArvrModalToggle = isOpen => {
        this.setState({ isArvrModalOpen: isOpen });
    };
    handleAppModalToggle = isOpen => {
        this.setState({ isAppModalOpen: isOpen });
    };
    handleHtmlModalToggle = isOpen => {
        this.setState({ isHtmlModalOpen: isOpen });
    };
    handleDesignModalToggle = isOpen => {
        this.setState({ isDesignModalOpen: isOpen });
    };
    handleappdevModalToggle = isOpen => {
        this.setState({ isappdevModalOpen: isOpen });
    };


    componentDidMount() {
        // Check if we have a selected category
        const selectedCategory = sessionStorage.getItem('selectedCategory');
        if (selectedCategory === 'Game Development') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('Game Development')) {
                this.setState({ isUnityModalOpen: true });
            }
        } else if (selectedCategory === 'AR | VR') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('AR | VR')) {
                this.setState({ isArvrModalOpen: true });
            }
        } else if (selectedCategory === 'MIT App Inventor') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('MITAppInventor')) {
                this.setState({ isAppModalOpen: true });
            }
        } else if (selectedCategory === '3D Printings') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('3D Printings')) {
                this.setState({ isDesignModalOpen: true });
            }
        } else if (selectedCategory === 'MITAppInventor') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('MITAppInventor')) {
                this.setState({ isappdevModalOpen: true });
            }
        } else if (selectedCategory === 'HtmlEditor') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('HtmlEditor')) {
                this.setState({ isHtmlModalOpen: true });
            }
        } else if (selectedCategory === 'Robotics') {
            sessionStorage.removeItem('selectedCategory');
            if (this.hasAccessibleCategory('Robotics')) {
                this.setState({ isRoboticsModalOpen: true });
            }
        } else if (selectedCategory === 'More..') {
            sessionStorage.removeItem('selectedCategory');
        } else if (selectedCategory) {
            // Clear it immediately to prevent it from persisting
            sessionStorage.removeItem('selectedCategory');

            if (this.hasAccessibleCategory(selectedCategory)) {
                // Set the state to show coding category
                this.setState({
                    buttonsVisible: false,
                    showData: true,
                    selectedButton: selectedCategory
                });
            }
        }

        // Add event listener for clicks outside
        document.addEventListener('mousedown', this.handleClickOutside);

        // Set loaded state
        setTimeout(() => {
            this.setState({ loaded: true });
        });

        // Enable sign in button after delay
        setTimeout(() => {
            this.setState({ isSignInButtonDisabled: false });
            console.log('Sign in button enabled');
        }, 2000);

        // Set stop handler if provided
        if (this.props.setStopHandler) {
            this.props.setStopHandler(this.handlePlayingEnd);
        }

        // Listen for authentication changes to update module visibility dynamically
        window.addEventListener('login-state-changed', this.handleAuthUpdate);
        window.addEventListener('authDataUpdated', this.handleAuthUpdate);
    }
    handleML(button) {
        if (!isExtensionAccessible('mlblock')) {
            alert('You do not have access to the ML Environment. Please contact your administrator.');
            return;
        }
        this.setState(prevState => ({
            isHandleModalOpen: !prevState.isHandleModalOpen
        }));

    }

    handleAuthUpdate = () => {
        this.setState({
            isLoggedIn: this.isUserLoggedIn()
        });
    };

    // Remove event listener when the component unmounts
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('login-state-changed', this.handleAuthUpdate);
        window.removeEventListener('authDataUpdated', this.handleAuthUpdate);
    }

    handleButtonClick(button) {
        if (button === 'Game Development') {
            if (!this.hasAccessibleCategory('Game Development')) {
                alert('You do not have access to Game Development. Please contact your administrator.');
                return;
            }
            this.setState({ isUnityModalOpen: true });
        } else if (button === 'AR | VR') {
            if (!this.hasAccessibleCategory('AR | VR')) {
                alert('You do not have access to AR | VR. Please contact your administrator.');
                return;
            }
            this.setState({ isArvrModalOpen: true });
            console.log('ar vr button clicked');
        } else if (button === 'MIT App Inventor') {
            if (!this.hasAccessibleCategory('MITAppInventor')) {
                alert('You do not have access to App Development. Please contact your administrator.');
                return;
            }
            this.setState({ isAppModalOpen: true });
            console.log('app dev button clicked');
        } else if (button === 'HtmlEditor') {
            if (!this.hasAccessibleCategory('HtmlEditor')) {
                alert('You do not have access to Web Development. Please contact your administrator.');
                return;
            }
            this.setState({ isHtmlModalOpen: true });
            console.log('Html button clicked');
        } else if (button === '3D Printings') {
            if (!this.hasAccessibleCategory('3D Printings')) {
                alert('You do not have access to 3D Printings. Please contact your administrator.');
                return;
            }
            this.setState({ isDesignModalOpen: true });
            console.log('design button clicked');
        } else if (button === 'MITAppInventor') {
            if (!this.hasAccessibleCategory('MITAppInventor')) {
                alert('You do not have access to App Development. Please contact your administrator.');
                return;
            }
            this.setState({ isappdevModalOpen: true });
            console.log('app dev button clicked');
        } else if (button === 'Drones') {
            if (!this.hasAccessibleCategory('Drones')) {
                alert('You do not have access to Drones. Please contact your administrator.');
                return;
            }
        } else if (button === 'Robotics') {
            this.setState({ isRoboticsModalOpen: true });
        } else {
            this.setState({
                buttonsVisible: false,
                showData: button,
                selectedButton: button
            });
        }
    }


    handleBackButtonClick() { // Add this method
        console.log('Back button clicked'); // Log when back button is clicked
        this.setState({
            buttonsVisible: true,
            showData: false,
            selectedButton: '',
            showModal: false, // Ensure modal is closed
            dropdownVisible: false, // Hide the dropdown when going back
            isUnityModalOpen: false,
            isArvrModalOpen: false,
            isAppModalOpen: false,
            isHtmlModalOpen: false,
            isDesignModalOpen: false
        });
    }

    showNewModal() {
        this.setState({ showModal: true });
        console.log('Modal is open');
    }


    handleCloseDropdown = () => {
        this.setState({ dropdownVisible: false });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery ||
            prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }


    async handleSelect(extensionId) {
        // List of extensions that don't require login
        const noLoginRequired = ['python', 'blocks'];

        // Skip login check if extension is in noLoginRequired list
        if (noLoginRequired.includes(extensionId)) {
            console.log('Selected Extension ID:', extensionId);
            const selectedItem = this.getFilteredData().find(item => item.extensionId === extensionId);
            console.log('Selected Item:', selectedItem);
            if (selectedItem) {
                this.handleClose();
                this.props.onItemSelected(selectedItem);
            } else {
                console.error('Invalid selection:', extensionId);
            }
            return;
        }

        // For all other extensions, check login
        const login = this.isUserLoggedIn();
        if (login === true) {
            if (!isExtensionAccessible(extensionId)) {
                alert('You do not have access to this module. Please contact your administrator to assign this module.');
                return;
            }

            console.log('Selected Extension ID:', extensionId);
            const selectedItem = (this.props.data || []).find(item => item.extensionId === extensionId);
            console.log('Selected Item:', selectedItem);
            if (selectedItem) {
                this.handleClose();
                this.props.onItemSelected(selectedItem);
            } else {
                console.error('Invalid selection:', extensionId);
            }
        } else {
            this.setState(prevState => ({
                dropdownVisible: !prevState.dropdownVisible
            }));
        }
    }

    handleClose() {

        this.props.onRequestClose();
        // // Close the modal and ensure the dropdown remains hidden
        this.setState({
            showModal: false, // Close the modal
            dropdownVisible: false // Ensure the dropdown is closed
        });
    }
    handleTagClick(tag) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: '',
                selectedTag: tag.toLowerCase()
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: '',
                playingItem: null,
                selectedTag: tag.toLowerCase()
            });
        }
    }
    handleMouseEnter(id) {
        if (this.props.onItemMouseEnter && this.state.playingItem !== id) {
            this.props.onItemMouseEnter(this.getFilteredData()[id]);
            this.setState({
                playingItem: id
            });
        }
    }
    handleMouseLeave(id) {
        if (this.props.onItemMouseLeave) {
            this.props.onItemMouseLeave(this.getFilteredData()[id]);
            this.setState({
                playingItem: null
            });
        }
    }
    handlePlayingEnd() {
        if (this.state.playingItem !== null) {
            this.setState({
                playingItem: null
            });
        }
    }
    handleFilterChange(event) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: event.target.value,
                selectedTag: ALL_TAG.tag
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: event.target.value,
                playingItem: null,
                selectedTag: ALL_TAG.tag
            });
        }
    }
    handleButtonMouseEnter(button) {
        this.setState({ hoveredButton: button });
    }

    handleButtonMouseLeave() {
        this.setState({ hoveredButton: null });
    }
    handleFilterClear() {
        this.setState({ filterQuery: '' });
    }

    signInButtonOnClick() {
        this.setState({ dropdownVisible: false });
    }

    handleClickOutside = event => {
        // Check if dropdownRef exists and has a current property
        if (this.dropdownRef && this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ dropdownVisible: false });
        }
    };

    handleRoboticsOptionSelect = option => {
        this.setState({
            isRoboticsModalOpen: false
        }, () => {
            if (option === 'python') {
                // Navigate to Python tab
                if (this.props.onNavigateToPython) {
                    this.props.onNavigateToPython();
                }
                // Close the library modal
                this.handleClose();
            } else if (option === 'scratch') {
                this.setState({
                    buttonsVisible: false,
                    showData: 'ScratchRobotics',
                    selectedButton: 'Robotics'
                });
            } else if (option === 'python_scratch') {
                this.setState({
                    buttonsVisible: false,
                    showData: 'PythonRobotics',
                    selectedButton: 'PythonRobotics'
                });
            }
        });
    };

    renderButtonContent() {
        const { showData } = this.state;
        return contentMap[showData] || null;
    }

    isUserLoggedIn() {
        return Boolean(localStorage.getItem('accessToken'));
    }

    async handleSignOutButtonClick() {
        try {
            const sessionId = localStorage.getItem('sessionId');
            if (!sessionId) {
                console.err('No sessions!');
            }
            await apiClient.post('/auth/logout', {
                sessionId: sessionId
            });
            localStorage.removeItem('accessToken');
            localStorage.removeItem('userId');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('userRole');
            localStorage.removeItem('accessibleModules');
            window.dispatchEvent(new Event('login-state-changed'));
            this.setState({
                isLoggedIn: false,
                dropdownVisible: true
            });
        } catch (error) {
            console.error('Error during logout:', error);
            // Still redirect to login page even if the server call fails
            localStorage.removeItem('accessToken');
            localStorage.removeItem('userId');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('userRole');
            localStorage.removeItem('accessibleModules');
            window.dispatchEvent(new Event('login-state-changed'));
            this.setState({
                isLoggedIn: false,
                dropdownVisible: true
            });
        }
    }

    getFilteredData() {
        if (!this.state.showData) return [];
        let items = this.props.data || [];

        // Role-Based Access Control filtering:
        // - Not logged in: Show all modules
        // - Admin: Show all modules
        // - Regular User: Show only assigned modules (plus free modules)
        items = items.filter(dataItem => isExtensionAccessible(dataItem.extensionId));

        if (this.state.selectedTag === 'all') {
            if (!this.state.filterQuery) return items;
            const res = items.filter(dataItem => (
                (dataItem.tags || [])
                    .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                    .concat(dataItem.name ?
                        (typeof dataItem.name === 'string' ?
                            dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
                        ).toLowerCase() :
                        null)
                    .join('\n')
                    .indexOf(this.state.filterQuery.toLowerCase()) !== -1
            ));
            console.log(res);
            return res;
        }
        return items.filter(dataItem => (
            dataItem.tags &&
            dataItem.tags
                .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                .indexOf(this.state.selectedTag) !== -1
        ));
    }

    /**
     * Check if a category has at least one accessible module for the current user
     * @param {string} categoryName
     * @returns {boolean}
     */
    hasAccessibleCategory(categoryName) {
        const items = this.props.data || [];

        // Standalone environments & tools
        if (categoryName === 'HtmlEditor' || categoryName === 'Web Development' || categoryName === 'Web & App Development') {
            return isExtensionAccessible('HtmlEditor') || isExtensionAccessible('web_development');
        }
        if (categoryName === 'MITAppInventor' || categoryName === 'App Development' || categoryName === 'MIT App Inventor') {
            return isExtensionAccessible('MITAppInventor') || isExtensionAccessible('app_development');
        }
        if (categoryName === 'AR | VR' || categoryName === 'ar_vr') {
            return isExtensionAccessible('ar_vr') || isExtensionAccessible('AR | VR');
        }
        if (categoryName === '3D Printings' || categoryName === '3d_printing' || categoryName === 'Design') {
            return isExtensionAccessible('3d_printing') || isExtensionAccessible('3D Printings');
        }
        if (categoryName === 'Game Development' || categoryName === 'game_development') {
            return isExtensionAccessible('game_development') || isExtensionAccessible('Game Development');
        }
        if (categoryName === 'Drones' || categoryName === 'drones') {
            return isExtensionAccessible('drones') || isExtensionAccessible('Drones');
        }

        if (categoryName === 'ML Environment' || categoryName === 'Machine Learning') {
            return isExtensionAccessible('mlblock');
        }

        if (categoryName === 'Robotics') {
            return items.some(item =>
                (item.category?.toLowerCase() === 'robotics' || item.category?.toLowerCase() === 'pythonrobotics') &&
                isExtensionAccessible(item.extensionId)
            );
        }

        if (categoryName === 'AI | ML' || categoryName === 'Artificial Intelligence') {
            return items.some(item =>
                (item.category?.toLowerCase() === 'ai | ml' || item.category?.toLowerCase() === 'artificial intelligence') &&
                isExtensionAccessible(item.extensionId)
            );
        }

        if (categoryName === 'All Extensions Section' || categoryName === 'All Extensions/Projects') {
            return items.some(item =>
                (item.category?.toLowerCase() === 'all extensions section' || item.category?.toLowerCase() === 'all extensions/projects') &&
                isExtensionAccessible(item.extensionId)
            );
        }

        return items.some(item =>
            item.category?.toLowerCase() === categoryName.toLowerCase() &&
            isExtensionAccessible(item.extensionId)
        );
    }
    scrollToTop() {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef(ref) {
        this.filteredDataRef = ref;
    }
    render() {
        return (
            <Modal
                fullScreen
                contentLabel={this.props.title}
                id={this.props.id}
                onRequestClose={this.handleClose}

            >
                {this.state.isHandleModalOpen && (
                    <MLEnv
                        isOpen={this.state.isHandleModalOpen}
                        onClose={this.handleML}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0, 0, 0, 0.9)', // Darker overlay
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}
                    >
                        {/* Modal content */}
                        <div>Welcome to the Full-Screen ML Environment</div>
                    </MLEnv>

                )}
                <Button
                    className="absolute right-4 top-2.5 bg-blue-700 hover:bg-blue-600 text-white px-4 py-2 rounded-full"
                    onClick={this.isUserLoggedIn() ? this.handleSignOutButtonClick : this.handleSignInButtonClick}
                >
                    <span className="flex items-center justify-center">
                        {this.isUserLoggedIn() ? (
                            <>
                                <LogOut
                                    className="mr-2 inline-block"
                                    size={20}
                                />
                                <span className="text-sm font-semibold">Logout</span>
                            </>
                        ) : (
                            <>
                                <LogIn
                                    className="mr-2 inline-block"
                                    size={20}
                                />
                                <span className="text-sm font-semibold">Sign In</span>
                            </>
                        )}
                    </span>
                </Button>


                {/* Only show dropdown if not logged in and dropdown is visible */}
                {!this.isUserLoggedIn() && this.state.dropdownVisible && (
                    <LoginDropdown
                        isOpen={this.state.dropdownVisible}
                        onClose={this.handleCloseDropdown}
                    />
                )}
                <div
                    className="bg-gradient-to-br from-sky-400 via-indigo-200 to-purple-300"
                    style={{
                        minHeight: 'calc(100vh - 3.7rem)',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        width: '100%',
                        maxWidth: '100%',
                        minWidth: 0,
                        boxSizing: 'border-box',
                        overflowX: 'hidden'
                    }}
                >

                    {!this.state.buttonsVisible && (
                        <button
                            className={classNames(styles.backButton, 'bg-blue-700 rounded-full')}
                            onClick={this.handleBackButtonClick}
                        >

                            <span className="flex items-center justify-center text-white">
                                <ChevronLeftCircleIcon
                                    className="mr-2 leading-none inline-block"
                                    size={20}
                                />
                                <span className="text-base font-semibold">
                                    Back
                                </span>
                            </span>
                        </button>
                    )}


                    {this.state.buttonsVisible && (
                        <>
                            <div
                                className="p-3 sm:p-4 md:p-6 flex-1 w-full"
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))',
                                    gap: '1.25rem',
                                    maxWidth: '1800px',
                                    width: '100%',
                                    margin: '0 auto',
                                    alignContent: 'start',
                                    boxSizing: 'border-box',
                                    minWidth: 0
                                }}
                            >

                                {/*  All Extensions Section */}
                                {this.hasAccessibleCategory('All Extensions Section') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'All Extensions Section' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('All Extensions Section')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={allExtensions}
                                        alt="All Extensions Section"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'All Extensions/Projects'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Explore fun and educational All Extensions-Projects to enhance your learning experience.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('All Extensions Section')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Coding card */}
                                {this.hasAccessibleCategory('Coding') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Coding' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Coding')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={codingImg}
                                        alt="Coding Environments"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Coding Enviroments'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Dive Into Coding!'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Coding')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Robotics Card */}
                                {this.hasAccessibleCategory('Robotics') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Robotics' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Robotics')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={Robotics}
                                        alt="Robotics"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Robotics'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Explore the exciting world of robotics!'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Robotics')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Artificial Intelligence Card */}
                                {this.hasAccessibleCategory('AI | ML') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'AI | ML' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('AI | ML')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={artificialintelligence}
                                        alt="Artificial Intelligence"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Artificial Intelligence'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Dive Into Artificial Intelligence and Machine Learning!'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('AI | ML')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* ML Environment Card */}
                                {this.hasAccessibleCategory('Machine Learning') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Machine Learning' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Machine Learning')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={mlImage}
                                        alt="ML Environment"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'ML Environment'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Dive into the world of machine learning and its applications.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleML('ML Environment')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* IoT | Electronics Card */}
                                {this.hasAccessibleCategory('IoT | Electronics') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'IoT | Electronics' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('IoT | Electronics')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={iot}
                                        alt="IoT | Electronics"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'IoT | Electronics'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Explore the world of connected devices and innovative electronics.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('IoT | Electronics')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* AR | VR Card */}
                                {this.hasAccessibleCategory('AR | VR') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'AR | VR' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('AR | VR')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={ar}
                                        alt="AR | VR"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'AR | VR'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Dive into the immersive world of Augmented and Virtual Reality.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('AR | VR')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* 3D Printings Card */}
                                {this.hasAccessibleCategory('3D Printings') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === '3D Printings' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('3D Printings')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={printing}
                                        alt="3D Printings"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'3D Printings'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Create stunning 3D models and learn the art of 3D printing.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('3D Printings')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* MIT App Inventor Card */}
                                {this.hasAccessibleCategory('MITAppInventor') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'MITAppInventor' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('MITAppInventor')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={mitAppInventorImage}
                                        alt="MIT App Inventor"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'App Development'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Explore how to build apps easily using App Development platform.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('MIT App Inventor')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Html Css Js Card */}
                                {this.hasAccessibleCategory('HtmlEditor') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'HtmlEditor' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('HtmlEditor')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={HtmlEditorImage}
                                        alt="Web Development"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Web Development'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Learn to make and Create your own webpages.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('HtmlEditor')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Mathematics Card */}
                                {this.hasAccessibleCategory('Mathematics') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Mathematics' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Mathematics')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={math}
                                        alt="Mathematics"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Mathematics'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Sharpen your skills with advanced math challenges.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Mathematics')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Geography Card */}
                                {this.hasAccessibleCategory('Geography') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Geography' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Geography')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={geography}
                                        alt="Geography"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Geography'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Explore the world with exciting geography challenges.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Geography')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                </div>
                                )}

                                {/* Cybersecurity Card */}
                                {this.hasAccessibleCategory('Cybersecurity') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Cybersecurity' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Cybersecurity')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={cyber}
                                        alt="Cybersecurity"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Cybersecurity'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Protect yourself and your data in the digital world.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Cybersecurity')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                    {this.state.hoveredButton === 'Cybersecurity' && (
                                        <div style={{
                                            position: 'absolute',
                                            inset: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0,0,0,0.62)',
                                            backdropFilter: 'blur(5px)',
                                            zIndex: 10
                                        }}>
                                            <div style={{
                                                background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: '0.95rem',
                                                padding: '10px 24px',
                                                borderRadius: '50px',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                                                letterSpacing: '0.06em',
                                                textTransform: 'uppercase'
                                            }}>
                                                {'Coming Soon'}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                )}

                                {/* Game Development */}
                                {this.hasAccessibleCategory('Game Development') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Game Development' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Game Development')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={gameEnvironmentImage}
                                        alt="Game Development"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Game Development'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Immerse yourself in interactive game design and environments.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Game Development')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                    {this.state.hoveredButton === 'Game Development' && (
                                        <div style={{
                                            position: 'absolute',
                                            inset: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0,0,0,0.62)',
                                            backdropFilter: 'blur(5px)',
                                            zIndex: 10
                                        }}>
                                            <div style={{
                                                background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: '0.95rem',
                                                padding: '10px 24px',
                                                borderRadius: '50px',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                                                letterSpacing: '0.06em',
                                                textTransform: 'uppercase'
                                            }}>
                                                {'Coming Soon'}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                )}

                                {/* Drones Card */}
                                {this.hasAccessibleCategory('Drones') && (
                                <div
                                    className="rounded-2xl overflow-hidden shadow-lg relative cursor-pointer"
                                    style={{
                                        height: '220px',
                                        transform: this.state.hoveredButton === 'Drones' ? 'scale(1.03)' : 'scale(1)',
                                        transition: 'all 0.3s ease-in-out'
                                    }}
                                    onMouseEnter={() => this.handleButtonMouseEnter('Drones')}
                                    onMouseLeave={this.handleButtonMouseLeave}
                                >
                                    <img
                                        src={drons}
                                        alt="Drones"
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                    />
                                    <div className="absolute inset-0"
                                        style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between gap-2">
                                        <div className="flex-1 min-w-0">
                                            <div className="text-white font-bold text-base mb-1 drop-shadow"
                                                style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>
                                                {'Drones'}
                                            </div>
                                            <p className="text-xs leading-relaxed"
                                                style={{ color: 'rgba(255,255,255,0.65)', textShadow: '0 1px 4px rgba(0,0,0,0.6)' }}>
                                                {'Discover the technology behind drones and their applications.'}
                                            </p>
                                        </div>
                                        <button
                                            className="flex-shrink-0 bg-indigo-600/80 hover:bg-indigo-500 text-white font-medium px-3 py-1.5 rounded-full text-xs transition-all duration-300 backdrop-blur-sm shadow-md active:scale-95"
                                            onClick={() => this.handleButtonClick('Drones')}
                                        >
                                            {'Learn More'}
                                        </button>
                                    </div>
                                    {this.state.hoveredButton === 'Drones' && (
                                        <div style={{
                                            position: 'absolute',
                                            inset: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0,0,0,0.62)',
                                            backdropFilter: 'blur(5px)',
                                            zIndex: 10
                                        }}>
                                            <div style={{
                                                background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: '0.95rem',
                                                padding: '10px 24px',
                                                borderRadius: '50px',
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                                                letterSpacing: '0.06em',
                                                textTransform: 'uppercase'
                                            }}>
                                                {'Coming Soon'}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                )}
                            </div>

                        </>
                    )}

                    {(this.props.filterable || this.props.tags) && (
                        <div
                            className={classNames(
                                styles.filterBar,
                                'bg-gradient-to-r from-cyan-600 via-blue-900 to-cyan-600' // Apply gradient to filterBar
                            )}
                        >
                            {this.props.filterable && (
                                <Filter
                                    className={classNames(
                                        styles.filterBarItem,
                                        styles.filter
                                    )}
                                    filterQuery={this.state.filterQuery}
                                    inputClassName={styles.filterInput}
                                    placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
                                    onChange={this.handleFilterChange}
                                    onClear={this.handleFilterClear}
                                />
                            )}
                            {this.props.filterable && this.props.tags && (
                                <Divider className={classNames(styles.filterBarItem, styles.divider)} />
                            )}
                            {this.props.tags && (
                                <div className={styles.tagWrapper}>
                                    {tagListPrefix.concat(this.props.tags).map((tagProps, id) => (
                                        <TagButton
                                            active={this.state.selectedTag === tagProps.tag.toLowerCase()}
                                            className={classNames(
                                                styles.filterBarItem,
                                                styles.tagButton,
                                                tagProps.className
                                            )}
                                            key={`tag-button-${id}`}
                                            onClick={() => this.handleTagClick(tagProps.tag)}
                                            {...tagProps}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {!this.state.buttonsVisible && (
                        <div
                            className={classNames(styles.libraryScrollGrid, {
                                [styles.withFilterBar]: this.props.filterable || this.props.tags
                            })}
                            ref={this.setFilteredDataRef}
                            style={{ flex: 1 }}
                        >
                            {this.state.loaded ? (
                                (() => {
                                    const displayedItems = this.getFilteredData()
                                        .filter(dataItem => this.state.selectedButton === '' || dataItem?.category?.toLowerCase() === this.state.selectedButton.toLowerCase());

                                    if (displayedItems.length === 0) {
                                        return (
                                            <div className="flex flex-col items-center justify-center p-12 text-center w-full col-span-full my-auto">
                                                <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center text-blue-500 mb-4 shadow-inner">
                                                    <PuzzlePiece size={32} />
                                                </div>
                                                <h3 className="text-xl font-bold text-gray-800 mb-2">No Modules Available</h3>
                                                <p className="text-sm text-gray-600 max-w-md mb-6">
                                                    You don't have access to any modules in this category. Please contact your administrator to assign modules to your account.
                                                </p>
                                                <button
                                                    className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-full text-sm transition-all duration-200 shadow-md flex items-center"
                                                    onClick={this.handleBackButtonClick}
                                                >
                                                    <ChevronLeftCircleIcon size={16} className="mr-2" />
                                                    Back to Categories
                                                </button>
                                            </div>
                                        );
                                    }

                                    return displayedItems.map((dataItem, index) => (
                                        <LibraryItem
                                            bluetoothRequired={dataItem.bluetoothRequired}
                                            collaborator={dataItem.collaborator}
                                            description={dataItem.description}
                                            disabled={dataItem.disabled}
                                            extensionId={dataItem.extensionId}
                                            featured={dataItem.featured}
                                            hidden={dataItem.hidden}
                                            iconMd5={dataItem.costumes ? dataItem.costumes[0].md5ext : dataItem.md5ext}
                                            iconRawURL={dataItem.rawURL}
                                            icons={dataItem.costumes}
                                            id={dataItem.extensionId}
                                            tags={dataItem.tags}
                                            insetIconURL={dataItem.insetIconURL}
                                            internetConnectionRequired={dataItem.internetConnectionRequired}
                                            isPlaying={this.state.playingItem === index}
                                            key={typeof dataItem.name === 'string' ? dataItem.name : dataItem.rawURL}
                                            name={dataItem.name}
                                            showPlayButton={this.props.showPlayButton}
                                            onMouseEnter={this.handleMouseEnter}
                                            onMouseLeave={this.handleMouseLeave}
                                            onSelect={this.handleSelect}
                                        />
                                    ));
                                })()
                            ) : (
                                <div className={styles.spinnerWrapper}>
                                    <Spinner
                                        large
                                        level="primary"
                                    />
                                </div>
                            )}
                        </div>
                    )}

                </div>
                <UnityGameModal
                    isOpen={this.state.isUnityModalOpen}
                    onClose={() => this.handleUnityModalToggle(false)}
                />
                <Arvrdocs
                    isOpen={this.state.isArvrModalOpen}
                    onClose={() => this.handleArvrModalToggle(false)}
                />
                <Appdocs
                    isOpen={this.state.isAppModalOpen}
                    onClose={() => this.handleAppModalToggle(false)}
                />
                <HTMLEditor
                    isOpen={this.state.isHtmlModalOpen}
                    onClose={() => this.handleHtmlModalToggle(false)}
                />
                <Design
                    isOpen={this.state.isDesignModalOpen}
                    onClose={() => this.handleDesignModalToggle(false)}

                />
                <Appdev
                    isOpen={this.state.isappdevModalOpen}
                    onClose={() => this.handleappdevModalToggle(false)}
                />
                {this.state.isRoboticsModalOpen && (() => {
                    const hasScratch = (this.props.data || []).some(item => item.category?.toLowerCase() === 'robotics' && isExtensionAccessible(item.extensionId));
                    const hasPythonScratch = (this.props.data || []).some(item => item.category?.toLowerCase() === 'pythonrobotics' && isExtensionAccessible(item.extensionId));
                    const hasPythonText = isExtensionAccessible('python');
                    const hasAnyOption = hasScratch || hasPythonScratch || hasPythonText;

                    return (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 animate-fadeIn">
                            <div className="bg-white p-8 rounded-lg text-center shadow-xl max-w-md w-full mx-4 transform transition-all duration-300 ease-in-out animate-scaleIn">
                                <h2 className="text-3xl font-bold mb-6 text-gray-800 flex items-center justify-center">
                                    <Code className="w-8 h-8 mr-2 text-blue-500" />
                                    Choose Robotics Programming Mode
                                </h2>
                                {hasAnyOption ? (
                                    <div className="flex flex-col space-y-4 mb-8">
                                        {hasScratch && (
                                            <button
                                                className="px-8 py-4 text-lg bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 shadow-md flex items-center justify-center"
                                                onClick={() => this.handleRoboticsOptionSelect('scratch')}
                                            >
                                                <PuzzlePiece className="w-6 h-6 mr-2" />
                                                <span className="font-bold">Scratch</span>
                                            </button>
                                        )}
                                        {hasPythonScratch && (
                                            <button
                                                className="px-8 py-4 text-lg bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 shadow-md flex items-center justify-center"
                                                onClick={() => this.handleRoboticsOptionSelect('python_scratch')}
                                            >
                                                <Code className="w-6 h-6 mr-2" />
                                                <span className="font-bold">Python Block Coding</span>
                                            </button>
                                        )}
                                        {hasPythonText && (
                                            <button
                                                className="px-8 py-4 text-lg bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-50 shadow-md flex items-center justify-center"
                                                onClick={() => this.handleRoboticsOptionSelect('python')}
                                            >
                                                <Terminal className="w-6 h-6 mr-2 text-white" />
                                                <span className="font-bold">Python Text Coding</span>
                                            </button>
                                        )}
                                    </div>
                                ) : (
                                    <div className="p-4 mb-6 bg-amber-50 border border-amber-200 rounded-lg text-amber-800 text-sm">
                                        No robotics modules are currently assigned to your account.
                                    </div>
                                )}
                                <button
                                    className="px-6 py-2 text-sm bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 flex items-center justify-center mx-auto"
                                    onClick={() => this.setState({ isRoboticsModalOpen: false })}
                                >
                                    <X className="w-4 h-4 mr-1" />
                                    Close
                                </button>
                            </div>
                        </div>
                    );
                })()}

            </Modal>
        );
    }
}

LibraryComponent.propTypes = {
    data: PropTypes.arrayOf(
        /* eslint-disable react/no-unused-prop-types, lines-around-comment */
        // An item in the library
        PropTypes.shape({
            // @todo remove md5/rawURL prop from library, refactor to use storage
            md5: PropTypes.string,
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]),
            rawURL: PropTypes.string
        })
        /* eslint-enable react/no-unused-prop-types, lines-around-comment */
    ),
    filterable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    onItemMouseEnter: PropTypes.func,
    onItemMouseLeave: PropTypes.func,
    onItemSelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    setStopHandler: PropTypes.func,
    onStartSelectingFileUpload: PropTypes.func.isRequired,
    showPlayButton: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    title: PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool,
    onRequestClose: PropTypes.func,
    intl: intlShape,
    onNavigateToPython: PropTypes.func // Add this line
    // signInButtonText: PropTypes.string, // New prop
    // signInButtonOnClick: PropTypes.func // New prop

};

LibraryComponent.defaultProps = {
    filterable: true,
    showPlayButton: true
    // signInButtonText: 'Sign In', // Default text
    // signInButtonOnClick: () => { } // Default no-op function
};

export default injectIntl(LibraryComponent);
